import { useCallback, useEffect, useMemo } from "react";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { defaultMST1020_R01Filter, useMST1020_R01Store, MST1020_R01Filter } from "./Store_MST1020_R01";
import { getMST1020_R01List, getMST1020_R01Items, downloadExcel_MST1020_R01, createSingleMST1020_R01, patchSingleMST1020_R01,  deleteSingleMST1020_R01, getMST1020_R01ItemsAllCount } from "./Api_MST1020_R01";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { showWarning, showSuccess, ShowSuccessFetch } from "src/utils/toast/toastUtil";

import { defaultBomData, MST1020_R01_BomDto, MST1020_R01HeaderDto } from "./Dto_MST1020_R01";
import {  downloadSettingExcel } from "src/utils/blob/blobUtil";
import {  fetchFilterConfig, gridRefSelectedRowHandler } from "src/utils/grid/GridHandlerContent";
import { ItemDto } from "src/dtos/item/itemDto";
import { AgGridReact } from "ag-grid-react";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	MST1020_R01_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';

interface Props {
	gridRef: React.RefObject<AgGridReact<MST1020_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<MST1020_R01_BomDto> | null>;
	
}

export const Content_MST1020_R01 = (props: Props) => {
	const { gridRef, detailGridRef } = props;
	useFetchActionbarAuth("MST1020_R01");
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { setMessage } = useUiuxStore();
	const {
		MST1020_R01Filter, setMST1020_R01Filter,
		MST1020_R01PastFilter, setMST1020_R01PastFilter,
		MST1020_R01ItemList, setMST1020_R01ItemList,
		selectedMST1020_R01Item, setSelectedMST1020_R01Item,
		MST1020_R01BomList, setMST1020_R01BomList,
		setSelectedMST1020_R01BomDetail,
		deletedMST1020_R01BomDetailList, addDeletedMST1020_R01BomDetailList, removeDeletedMST1020_R01BomDetailList,
		selectedMST1020_R01BomDetailList, setSelectedMST1020_R01BomDetailList,
		removeSelectedMST1020_R01BomDetailList,
		setOriginalMST1020_R01BomList,
		setAllCount,
		detailFetchTrigger, setDetailFetchTrigger,
		initData,
		setScrollTop,
		setDetailScrollTop,
	} = useMST1020_R01Store();
	const { 
		brandCdList, itemGroupList, itemAccountList, unitList, materialIntypeList, itemCdMap } = useCommonCodeStore();

	// 엑셀 다운로드
	const handleExcelClick = useCallback(async () => {
		if (!selectedMST1020_R01Item) {
			showWarning('선택된 품목이 없습니다.');
			return;
		}
		
		setLoadingSpinner(true);
		
		const response = await downloadExcel_MST1020_R01(
			selectedMST1020_R01Item.itemCd,
			MST1020_R01Filter.bomUseyn
		);

		downloadSettingExcel({ responseData: response.data.data, fileName: 'BOM 등록-excel.xlsx' });

		setLoadingSpinner(false);
			
	}, [selectedMST1020_R01Item, setLoadingSpinner, MST1020_R01Filter, MST1020_R01ItemList, setLoadingSpinner]);

	const getParams = (filter: MST1020_R01Filter, listLength: number = 0) => {
		const params = {
			searchText: filter.searchText,
			itemGroup: filter.itemGroup,
			itemAccount: filter.itemAccount,
			listLength: 0
		}
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const allCountResponse = await getMST1020_R01ItemsAllCount(getParams(MST1020_R01Filter, 0));
		setAllCount(allCountResponse.data.data);
		return allCountResponse.data.data;
	}, [MST1020_R01Filter, setAllCount]);

	// ✅ 상단 품목 목록 조회 (BOM 작성 가능한 품목만)
	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);

		const response = await getMST1020_R01Items(
			'',
			getParams(MST1020_R01Filter),
			MST1020_R01ItemList.length ?? 0
		);

		let newList = [...response.data.data ] as MST1020_R01HeaderDto[];
		setMST1020_R01ItemList(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList[0]) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedMST1020_R01Item,
				() => true,// () => !newList.find(value => value.itemCd === selectedMST1020_R01Item?.itemCd)
			);
			setMST1020_R01PastFilter(MST1020_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		} else {
			showWarning('조회된 데이터가 없습니다.');
			setSelectedMST1020_R01Item(undefined);
			setMST1020_R01BomList([]);
			removeDeletedMST1020_R01BomDetailList();
			setSelectedMST1020_R01BomDetailList([]);
		}
		setLoadingSpinner(false);
		
		return newList;
	}, [MST1020_R01Filter, MST1020_R01PastFilter, setMST1020_R01ItemList, setMST1020_R01PastFilter, setSelectedMST1020_R01Item, setMST1020_R01BomList, removeDeletedMST1020_R01BomDetailList, setSelectedMST1020_R01BomDetailList, setLoadingSpinner, setMessage, gridRef, renewalAllCount, getParams, setScrollTop, setDetailScrollTop]);

	// ✅ 하단 BOM 목록 조회 (품목 선택 시 자동 호출)
	const fetchBomList = useCallback(async (prntItemcd: string, bomUseyn?: string) => {
		if (!prntItemcd) return;
		
		setLoadingSpinner(true);
		const response = await getMST1020_R01List(prntItemcd, bomUseyn);
		const bomList = response.data.data;
		setMST1020_R01BomList(bomList);
		
		if (bomList.length > 0) {
			setSelectedMST1020_R01BomDetail(bomList[0]);
			setOriginalMST1020_R01BomList(bomList);
			detailGridRef.current?.api.ensureIndexVisible(0, 'top');
		} else {
			setSelectedMST1020_R01BomDetail(undefined);
			
			// ✅ BOM 데이터가 없는 경우 기본 행 추가 (SYS1010과 동일한 로직)
			if (selectedMST1020_R01Item) {
				const newBomRow = { 
					...defaultMST1020_R01BomRow(),
					prntItemcd: selectedMST1020_R01Item.itemCd,
					prntItemnm: selectedMST1020_R01Item.itemNm || '',
					prntItemUnit: selectedMST1020_R01Item.itemUnit || '',
				};
				// BOM 리스트에 새 행 추가
				setMST1020_R01BomList([newBomRow]);
			}
		}
		setLoadingSpinner(false);
		return bomList;
	}, [setMST1020_R01BomList, setSelectedMST1020_R01BomDetail, setLoadingSpinner, selectedMST1020_R01Item, unitList]);

	// 품목 선택 시 BOM 자동 조회
	useEffect(() => {
		if (!detailFetchTrigger) return;
		if (selectedMST1020_R01Item?.itemCd) {
			fetchBomList(selectedMST1020_R01Item.itemCd, MST1020_R01Filter.bomUseyn); // ✅ 사용여부 필터 적용
			setDetailFetchTrigger(false);
		}

		setMessage(`${selectedMST1020_R01Item?.itemNm}의 BOM 목록을 조회하였습니다.`);
		setTimeout(() => setMessage(""), 5000);
	}, [selectedMST1020_R01Item, fetchBomList, MST1020_R01Filter.bomUseyn]);

	const defaultMST1020_R01BomRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(MST1020_R01_ROW_VALIDATE, {
				brandCdList,
				itemAccountList,
				itemGroupList,
				materialIntypeList,
				unitList,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultBomData };
		}

		const returnData = {
			...defaultBomData,
			childItemUnit: unitList[0].minorCd,
			bomUseyn: 'Y',
			prntItemQty: 1,
			childItemUsage: 1,
			materialIntype: materialIntypeList[0].minorCd,
			brandCd: brandCdList[0].minorCd,
			itemGroup: itemGroupList[0].minorCd,
			itemAccount: itemAccountList[0].minorCd,
			inserted: true,
		};

		if (!selectedMST1020_R01Item) {
			return returnData;
		}

		return {
			...returnData,
			prntItemcd: selectedMST1020_R01Item.itemCd,
			prntItemnm: selectedMST1020_R01Item.itemNm || '',
			prntItemUnit: selectedMST1020_R01Item.itemUnit || '',
		};
	}, [
		defaultBomData, selectedMST1020_R01Item,
		brandCdList, itemGroupList, itemAccountList, unitList, materialIntypeList,
		validateCommonCodeLists,
	]);

	// 초기화
	const initItemData = useCallback(() => {
		setSelectedMST1020_R01Item(undefined);
		setMST1020_R01BomList([]);
		removeDeletedMST1020_R01BomDetailList();
		setSelectedMST1020_R01BomDetailList([]);
	}, [unitList]);

	const handleDeleteClick = useCallback(() => {
		if (deletedMST1020_R01BomDetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedMST1020_R01BomDetailList(deletedMST1020_R01BomDetailList);
			removeSelectedMST1020_R01BomDetailList();
			setMST1020_R01BomList([...MST1020_R01BomList]);
		} else if (selectedMST1020_R01BomDetailList.length > 0) {
			// 삭제 표시된 행이 없으면 선택된 행만 삭제 표시
			const processedList = selectedMST1020_R01BomDetailList.filter(value => 
				!deletedMST1020_R01BomDetailList.includes(value)
				&& (
					MST1020_R01BomList.find(item => item.prntItemcd === value)?.inserted !== true
					&& MST1020_R01BomList.find(item => item.prntItemcd === value)?.isModified !== true
				)
			);
			addDeletedMST1020_R01BomDetailList(processedList);
			removeSelectedMST1020_R01BomDetailList(processedList);
		}
	}, [
		selectedMST1020_R01BomDetailList,
		deletedMST1020_R01BomDetailList,
		addDeletedMST1020_R01BomDetailList,
		removeDeletedMST1020_R01BomDetailList,
		removeSelectedMST1020_R01BomDetailList,
		setMST1020_R01BomList,
		MST1020_R01BomList
	]);

	// 전체 초기화 (검색 조건 포함)
	const initContainerData = useCallback(() => {
		// Store 초기화 (모든 상태 초기화)
		initData();
		// Content의 검색 조건 초기화
		setMST1020_R01Filter({
			searchText: '',
			itemGroup: '',
			itemAccount: '',
			bomUseyn: 'Y'
		});
	}, [initData]);

	// 신규 생성
	const handleCreateClick = useCallback(() => {
		// 품목이 선택된 경우에만 새 BOM 행 추가
		if (selectedMST1020_R01Item?.itemCd) {
			const newBomRow = { ...defaultMST1020_R01BomRow(), };
			
			// 기존 BOM 리스트에 새 행 추가 (전체 교체 대신)
			setMST1020_R01BomList([...MST1020_R01BomList, newBomRow]);
		} else {
			initItemData();
		}
	}, [selectedMST1020_R01Item, setMST1020_R01BomList, unitList, MST1020_R01BomList, initItemData]);

	// BOM 데이터 유효성 검증
	const validateInsertData = (bomList: any[]) => {
		if (bomList.length === 0) {
			showWarning('BOM 상세내역을 입력해주세요.');
			return false;
		}
		
		// 자품목코드 중복 체크
		const childItemCodes = bomList.map(bom => bom.childItemcd).filter(code => code);
		const uniqueChildItemCodes = Array.from(new Set(childItemCodes));
		
		if (childItemCodes.length !== uniqueChildItemCodes.length) {
			// 중복된 자품목코드 찾기
			const duplicates = childItemCodes.filter((code, index) => 
				childItemCodes.indexOf(code) !== index
			);
			const uniqueDuplicates = Array.from(new Set(duplicates));
			
			showWarning(`중복된 자품목코드가 있습니다: ${uniqueDuplicates.join(', ')}`, 5000);
			return false;
		}

				// ✅ 순번 중복 체크 추가
		const bomSeqs = bomList.map(bom => bom.bomSeq).filter(seq => seq > 0);
		const uniqueBomSeqs = Array.from(new Set(bomSeqs));
		
		if (bomSeqs.length !== uniqueBomSeqs.length) {
			// 중복된 순번 찾기
			const duplicateSeqs = bomSeqs.filter((seq, index) => 
				bomSeqs.indexOf(seq) !== index
			);
			const uniqueDuplicateSeqs = Array.from(new Set(duplicateSeqs));
			
			showWarning(`중복된 순번이 있습니다: ${uniqueDuplicateSeqs.join(', ')}`, 5000);
			return false;
		}

		for (const bom of bomList) {
			if (!bom.prntItemcd) {
				showWarning('모품목코드를 입력해주세요.');
				return false;
			}
			if (!itemCdMap.has(bom.prntItemcd)) {
				showWarning('모품목코드가 해당 MES의 품목정보에 존재하지 않습니다.\n품목코드: ' + bom.prntItemcd); return false;
			}
			if (!bom.childItemcd) {
				showWarning('자품목코드를 입력해주세요.');
				return false;
			}
			if (!itemCdMap.has(bom.childItemcd)) {
				showWarning('자품목코드가 해당 MES의 품목정보에 존재하지 않습니다.\n품목코드: ' + bom.childItemcd); return false;
			}
			if (!bom.childItemUsage || bom.childItemUsage <= 0) {
				showWarning('소요량을 입력해주세요.');
				return false;
			}
		}
		return true;
	};

	// 저장
	const handleSaveClick = useCallback(async () => {
		if (!selectedMST1020_R01Item) {
			showWarning('선택된 품목이 없습니다.');
			return;
		}

		const newBomList = MST1020_R01BomList.filter(value => 
			!deletedMST1020_R01BomDetailList.includes(value.prntItemcd)
		);

		    //  orderIndex 기준으로 bomSeq 재계산
			const reorderedBomList = newBomList
			.sort((a, b) => (a.orderIndex || 0) - (b.orderIndex || 0))
			.map((bom, index) => {
				const newBomSeq = index + 1;
				return {
					...bom,
					bomSeq: newBomSeq,
					// 💡 bomSeq가 실제로 변경되면 isModified = true
					// 원인은 상관없음 (드래그든, 직접 수정이든)
					isModified: bom.isModified || bom.bomSeq !== newBomSeq
				};
			});

		if (!validateInsertData(reorderedBomList)) return;

		// console.log('=== 저장 시작 ===');
		// console.log('전체 BOM 리스트:', MST1020_R01BomList);
		// console.log('삭제 제외 BOM 리스트:', newBomList);

		setLoadingSpinner(true);
		try {
			// 신규 생성 목록 준비
			const insertList = newBomList
				.filter(bom => bom.inserted)
				.map(bom => ({
					prntItemcd: bom.prntItemcd,
					childItemcd: bom.childItemcd,
					bomSeq: bom.bomSeq,
					bomUseyn: bom.bomUseyn,
					bomUpdateNo: bom.bomUpdateNo,
					prntItemQty: bom.prntItemQty,
					prntItemUnit: bom.prntItemUnit,
					childItemUsage: bom.childItemUsage,
					childItemUnit: bom.childItemUnit,
					fixLossqty: bom.fixLossqty,
					lossPercent: bom.lossPercent,
					applyBeginDt: bom.applyBeginDt,
					applyEndDt: bom.applyEndDt,
					materialIntype: bom.materialIntype,
					remark: bom.remark
				}));

			// 수정 목록 준비 (사용여부 'N' 변경 제외)
			const updateTargets = newBomList.filter(bom => 
				bom.isModified && !bom.inserted && bom.bomUseyn !== 'N'
			);
			
			const updateList = updateTargets.map(bom => ({
					prntItemcd: bom.prntItemcd,
					childItemcd: bom.childItemcd,
					bomSeq: bom.bomSeq,
					bomUseyn: bom.bomUseyn,
					bomUpdateNo: bom.bomUpdateNo,
					prntItemQty: bom.prntItemQty,
					prntItemUnit: bom.prntItemUnit,
					childItemUsage: bom.childItemUsage,
					childItemUnit: bom.childItemUnit,
					fixLossqty: bom.fixLossqty,
					lossPercent: bom.lossPercent,
					applyBeginDt: bom.applyBeginDt,
					applyEndDt: bom.applyEndDt,
					materialIntype: bom.materialIntype ,
					remark: bom.remark
				}));

			// ✅ 사용여부 'N' 변경 목록 별도 처리
			const userDeactivateTargets = newBomList.filter(bom => 
				bom.isModified && !bom.inserted && bom.bomUseyn === 'N'
			);
			// console.log('🔴 사용자가 직접 비활성화한 목록:', userDeactivateTargets);

			// ✅ BOM 비활성화: bomUseyn을 'N'으로 변경 (실제 삭제가 아님)
			const buttonDeactivateTargets = deletedMST1020_R01BomDetailList
				.map(deletedId => MST1020_R01BomList.find(b => b.childItemcd === deletedId))
				.filter(deletedBom => deletedBom && !deletedBom.inserted);
			
			// 모든 비활성화 대상 통합 (삭제 버튼 + 직접 변경)
			const allDeactivateTargets = [...buttonDeactivateTargets, ...userDeactivateTargets];

			// API 호출
			const promises = [];
			
			// 신규 생성 목록 개별 처리
			for (const item of insertList) {
				promises.push(createSingleMST1020_R01(item));
			}
			
			// 수정 목록 개별 처리
			for (const item of updateList) {
				promises.push(patchSingleMST1020_R01(item));
			}
			
			// ✅ 비활성화 목록 개별 처리 (사용여부를 'N'으로 변경)
			for (const deletedBom of allDeactivateTargets) {
				const deactivateData = {
					prntItemcd: deletedBom!.prntItemcd,
					childItemcd: deletedBom!.childItemcd,
					bomSeq: deletedBom!.bomSeq,
					bomUpdateNo: deletedBom!.bomUpdateNo,
					bomUseyn: 'N', // ✅ 사용여부를 'N'으로 명시적 설정
					prntItemQty: deletedBom!.prntItemQty,
					prntItemUnit: deletedBom!.prntItemUnit,
					childItemUsage: deletedBom!.childItemUsage,
					childItemUnit: deletedBom!.childItemUnit,
					fixLossqty: deletedBom!.fixLossqty,
					lossPercent: deletedBom!.lossPercent,
					applyBeginDt: deletedBom!.applyBeginDt,
					applyEndDt: deletedBom!.applyEndDt,
					remark: deletedBom!.remark
				};
				promises.push(deleteSingleMST1020_R01(deactivateData));
			}
			
			// 모든 API 호출 완료 대기
			if (promises.length > 0) {
				const results = await Promise.all(promises);
			}

			// console.log('🎉 모든 저장 작업 완료');
			showSuccess('BOM 저장이 완료되었습니다.');
			
			// ✅ 비활성화 관련 상태 초기화  
			removeDeletedMST1020_R01BomDetailList();
			setSelectedMST1020_R01BomDetailList([]);
			
			// 데이터 새로고침
			if (selectedMST1020_R01Item.itemCd) {
				await fetchBomList(selectedMST1020_R01Item.itemCd, MST1020_R01Filter.bomUseyn); // ✅ 사용여부 필터 적용
			}
		} catch (error) {
			showWarning('저장 중 오류가 발생했습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [
		selectedMST1020_R01Item,
		MST1020_R01BomList,
		deletedMST1020_R01BomDetailList,
		fetchBomList,
		setLoadingSpinner
	]);

	return {
		handleExcelClick,
		fetchData,
		fetchBomList,
		defaultMST1020_R01BomRow,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	};
}; 